export default "__VITE_ASSET__DusAP2PO__"